// extracted by mini-css-extract-plugin
export var active = "_c7-7";
export var container = "_c7-0";
export var evenWidth = "_c7-4";
export var large = "_c7-5";
export var outlet = "_c7-8";
export var slide = "_c7-2";
export var small = "_c7-6";
export var tab = "_c7-3";
export var tabs = "_c7-1";